export default "__VITE_PUBLIC_ASSET__f650eca9__"